import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import {
  LiffHomeMenuConfig,
  LiffHomeMenuConfigResponse,
} from '../../../models/liff-home-menu.model';

@Injectable({
  providedIn: 'root',
})
export class ApiLiffHomeMenuService {
  private privateApiUrl = `${environment.apiPrivateUrl}`;
  /** Session-scoped HTTP cache — one GET until tab/LIFF closed */
  private config$?: Observable<LiffHomeMenuConfigResponse>;

  constructor(private http: HttpClient) {}

  /*############################################# API #################################################*/

  /**
   * Global LIFF Home Quick/More menu config
   * GET /CityParking/getLiffHomeMenuConfig
   * Cached once per browser session (shareReplay).
   */
  getLiffHomeMenuConfig(): Observable<LiffHomeMenuConfigResponse> {
    if (!this.config$) {
      this.config$ = this.http
        .get<LiffHomeMenuConfigResponse>(
          `${this.privateApiUrl}/CityParking/getLiffHomeMenuConfig`,
        )
        .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.config$;
  }
}

export type { LiffHomeMenuConfig };
